export default {"src":"/_next/static/media/down-arrow.84bd6c00.svg","height":24,"width":24};